import React from 'react'
import { connect } from 'react-redux'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import MyContentItem from './my-content-item'
import './index.scss'
import chunk from 'lodash/chunk'
import sortIcon from '../../../../../asset/sort.png'
import { getLatLngGeoson } from '../../../main-ui/common/commonfunctions'
import { updateMapCenterLatLng, updateMapCenterNull } from '../../../../action/map-center-action'
import { toggleContentTypeVisibility } from '../../../../action/hidden-content-types-actions'

class MyContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: [],
      activeShapeId: this.props.selectedObjId,
      sortOption: { label: 'Most Recent', value: 'dateNewToOld' },
      types: ['markers', 'huntStands', 'photos', 'shapes', 'tracks', 'routes', 'boundaries'],
      isOpen: false,
      searchQuery: '',
      searchData: [],
      searchedData: [],
      mapCenter: {},
      selectedType: null,
      sectionLimits: {},
    }
    this.mapListener = null
    this.filterData = []
    this.counter = 0
  }

  componentDidMount() {
    const { collapseLeftToolbar, mapReference, markers, huntStands, photos, tracks, routes, boundaries, lines, polygons, circles, updateMapCenterLatLng } = this.props
    this.setState({ mapCenter: { lat: mapReference.getCenter().lat(), lng: mapReference.getCenter().lng() }, searchData: [...markers, ...huntStands, ...photos, ...tracks, ...routes, ...boundaries, ...lines, ...polygons, ...circles] })
    if (mapReference) {
      const newCenter = mapReference.getCenter();
      const newMapReference = {
        lat: newCenter.lat(),
        lng: newCenter.lng(),
      };
      updateMapCenterLatLng(newMapReference);
      // Add the dragend event listener to the map
      this.mapListener = mapReference.addListener('dragend',
        (e) => {
          this.handleDragEnd();
          if (this.state.activeShapeId) {

          }
        }
      );
    }
  }

  handleDragEnd = () => {
    const { mapReference, updateMapCenterLatLng } = this.props;
    const newCenter = mapReference.getCenter();
    const newMapReference = {
      lat: newCenter.lat(),
      lng: newCenter.lng(),
    };
    if (this.state.sortOption.value == 'sortClosest' || this.state.sortOption.value == 'sortFarthest') {
      updateMapCenterLatLng(newMapReference);
    }
  };

  componentWillUnmount() {
    const { updateMapCenterNull } = this.props;
    // Remove the event listener when the component is unmounted
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      updateMapCenterNull()
      this.setState({ reRender: 0 })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedObjId !== this.props.selectedObjId) {
      this.setState({ activeShapeId: this.props.selectedObjId });
    }
  }

  sortFunction(dataList, type) {
    let data
    if (this.state.sortOption) {
      if (this.state.sortOption.value == 'nameAtoZ') {
        data = dataList.sort((a, b) => {
          const nameA = a.name?.toUpperCase();
          const nameB = b.name?.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else if (this.state.sortOption.value == 'nameZtoA') {
        data = dataList.sort((b, a) => {
          const nameA = a.name?.toUpperCase();
          const nameB = b.name?.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else if (this.state.sortOption.value == 'dateOldToNew') {
        data = dataList.sort((a, b) => {
          const dateA = new Date(a.created).getTime();
          const dateB = new Date(b.created).getTime();
          return dateA - dateB;
        });
      } else if (this.state.sortOption.value == 'dateNewToOld') {
        data = dataList.sort((b, a) => {
          const dateA = new Date(a.created).getTime();
          const dateB = new Date(b.created).getTime();
          return dateA - dateB;
        });
      } else if (this.state.sortOption.value == 'sortClosest') {
        data = this.sortMarkersByDistance(dataList.slice(), true);
      } else if (this.state.sortOption.value == 'sortFarthest') {
        data = this.sortMarkersByDistance(dataList.slice(), false);
      } else {
        data = dataList
      }
    } else {
      data = dataList
    }
    return data
  }

  // Create a separate handler for onClick logic
  handleClick = (name, idx, doubleClick) => {
    if (this.state.selectedType && doubleClick) {
      this.setState({ selectedType: null });
    }

    const clone = [...this.state.expanded];
    if (idx === -1) {
      clone.push(name);
    } else {
      clone.splice(idx, 1);
      // Reset pagination when section is collapsed
      const { [name]: _, ...restLimits } = this.state.sectionLimits;
      this.setState({ expanded: clone, isOpen: false, sectionLimits: restLimits });
      return;
    }
    this.setState({ expanded: clone, isOpen: false });
  }

  makeExpandable(name, index) {
    const { expanded, activeShapeId, selectedType, types } = this.state;
    let wantedValues = [...expanded]; // Make a copy to avoid direct mutation
    if (selectedType && !wantedValues.includes(selectedType)) {
      wantedValues.push(selectedType);
    }
    const idx = wantedValues.indexOf(name),
      nameMap = {
        huntStands: 'Hunt Stands',
        boundaries: 'Favorite Locations'
      }
    let expandedData
    if (name == 'photos') {
      expandedData = this.props[name].filter((item) => {
        if (item.latitude || item.longitude) {
          return item
        }
      })
    } else {
      expandedData = this.props[name]
    }

    const handleClickRef = (e, doubleClick) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleClick(name, idx, doubleClick);
    };

    return (
      <div className='layer-node'
        key={index}
        style={{
          textTransform: 'capitalize'
        }}
      // onClick={(e) => handleClickRef(e, true)}
      // key={`myContentNode-${name}`}

      // onClick={(e) => {
      //   // Prevent click events from child divs (if needed)
      //   e.stopPropagation();
      //   handleClickRef(e, true);
      // }}

      // onClick={(e) => handleClickRef(e, false)}  // Wrap in an arrow function


      // onClick={(e) => {
      //   console.log('onclik is called withoud click')
      //   e.preventDefault(); // Prevent default behavior
      //   e.stopPropagation(); // Stop event from bubbling up
      //   if (this.state.selectedType) {
      //     console.log('why this is called without clicking', selectedType)
      //     this.setState({ selectedType: null });
      //   }
      //   const clone = [].concat(expanded)
      //   if (idx === -1) {
      //     clone.push(name)
      //     this.setState({ expanded: clone, isOpen: false, })
      //   } else {
      //     clone.splice(idx, 1)
      //     this.setState({ expanded: clone, isOpen: false, })
      //   }
      //   if (wantedValues.includes(name)) {
      //     this.setState({ expanded: clone, isOpen: false, })
      //   }
      // }}
      >

        <div style={{ display: 'flex', alignItems: 'center', width: '300px' }}>
          <div style={{ width: '40px' }}>
            <div style={{
              width: 25,
              height: 25,
              border: '2px solid #959595',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#333333',
              cursor: 'pointer'
            }}
              onClick={(e) => handleClickRef(e, true)}
            >
              <p className='layer-icon-plus-minus'>{idx !== -1 ? '-' : '+'}</p>
            </div>
          </div>
          <div className='content-title' >
            {nameMap[name] ? nameMap[name] : name}
            <p className='length-of-content' style={{ cursor: 'default' }}>({expandedData.length})</p>
          </div>
          {/* Favorite Locations has no map representation (saved camera views), so no eye. */}
          {name !== 'boundaries' && (() => {
            const isHidden = this.props.hiddenContentTypes.includes(name)
            return (
              <div
                className='content-visibility-toggle'
                title={isHidden ? 'Show on map' : 'Hide from map'}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  this.props.toggleContentTypeVisibility(name)
                }}
              >
                {isHidden
                  ? <VisibilityOff style={{ fontSize: 22, color: '#6E6E6E' }} />
                  : <Visibility style={{ fontSize: 22, color: '#9ECC3B' }} />}
              </div>
            )
          })()}
        </div>
        {idx !== -1 ? this.expanded(expandedData, name, activeShapeId) : null}
      </div>
    )
  }

  // Define the sortMarkersByDistance function
  sortMarkersByDistance(markers, isClosest) {
    // Clone the array to avoid mutating the original array
    const sortedMarkers = [...markers];
    // Reference Position
    const mapCenter = this.props.mapCenter;
    const referenceMarker = { latitude: mapCenter.lat, longitude: mapCenter.lng };
    // Calculate distances of all markers from the reference marker
    if (isClosest) {
      sortedMarkers.sort((a, b) => {
        a.latitude = a.latitude ? a.latitude : getLatLngGeoson(a, 'latitude')
        a.longitude = a.longitude ? a.longitude : getLatLngGeoson(a, 'longitude')
        b.latitude = b.latitude ? b.latitude : getLatLngGeoson(b, 'latitude')
        b.longitude = b.longitude ? b.longitude : getLatLngGeoson(b, 'longitude')
        const distanceA = this.calculateDistance(referenceMarker.latitude, referenceMarker.longitude, a.latitude, a.longitude);
        const distanceB = this.calculateDistance(referenceMarker.latitude, referenceMarker.longitude, b.latitude, b.longitude);
        return distanceA - distanceB;
      });
    } else {
      sortedMarkers.sort((b, a) => {
        a.latitude = a.latitude ? a.latitude : getLatLngGeoson(a, 'latitude')
        a.longitude = a.longitude ? a.longitude : getLatLngGeoson(a, 'longitude')
        b.latitude = b.latitude ? b.latitude : getLatLngGeoson(b, 'latitude')
        b.longitude = b.longitude ? b.longitude : getLatLngGeoson(b, 'longitude')
        const distanceA = this.calculateDistance(referenceMarker.latitude, referenceMarker.longitude, a.latitude, a.longitude);
        const distanceB = this.calculateDistance(referenceMarker.latitude, referenceMarker.longitude, b.latitude, b.longitude);
        return distanceA - distanceB;
      });
    }
    return sortedMarkers;
  }

  // Function to calculate the distance between two points
  calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.toRadians(lat2 - lat1);
    const dLon = this.toRadians(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  }

  // Function to convert degrees to radians
  toRadians(degrees) {
    return degrees * Math.PI / 180;
  }

  expanded(content, type) {
    let filterData = content.length > 0 && this.sortFunction(content),
      { activeShapeId, sectionLimits } = this.state
    let setHideFunction = (type) => {
      const clone = [].concat(this.state.expanded)
      clone.push(type)
      this.setState({ isOpen: false, selectedType: type })
    }
    const PAGE_SIZE = 50
    const limit = type ? (sectionLimits[type] ?? PAGE_SIZE) : (filterData ? filterData.length : 0)
    const visible = filterData ? filterData.slice(0, limit) : []
    const remaining = filterData ? filterData.length - visible.length : 0
    return (
      <div style={{ padding: '10px', display: 'flex', flexWrap: 'wrap', cursor: 'pointer' }}>
        {
          visible.map((data, index) => (
            <div className='my-content-row' key={index} style={{}}>
              <MyContentItem data={data} active={activeShapeId === data.id} setActive={this.setActive.bind(this)} type={type} setHideFunction={setHideFunction} />
            </div>
          ))
        }
        {remaining > 0 && (
          <div
            style={{ width: '100%', textAlign: 'center', padding: '8px', cursor: 'pointer', color: '#9ECC3B', fontSize: '13px' }}
            onClick={() => this.setState(prev => ({
              sectionLimits: { ...prev.sectionLimits, [type]: (prev.sectionLimits[type] ?? PAGE_SIZE) + PAGE_SIZE }
            }))}
          >
            Show more ({remaining} remaining)
          </div>
        )}
      </div>
    )
  }

  setActive(id, data, infoWindowCb) {
    const { updateMapCenterLatLng } = this.props;
    this.setState(
      {
        activeShapeId: id,
      },
      () => {
        infoWindowCb && infoWindowCb.infoWindowFunction && infoWindowCb.infoWindowFunction.close()
        this.setState({ activeShapeId: id, })
        let newMapReference;

        switch (data.measureType) {
          case "circle": {
            try {
              let geoSonData = JSON.parse(data.geoJson)
              let value = geoSonData.features[0].geometry.coordinates
              newMapReference = { lat: value[0], lng: value[1] }
              updateMapCenterLatLng(newMapReference);
            } catch (e) { console.warn('MyContent circle geoJson parse error', e) }
            break;
          }
          case "line": {
            try {
              let geoSonData = JSON.parse(data.geoJson)
              let value = geoSonData.features[0].geometry.coordinates[0]
              newMapReference = { lat: value[0], lng: value[1] }
              updateMapCenterLatLng(newMapReference);
            } catch (e) { console.warn('MyContent line geoJson parse error', e) }
            break;
          }
          case "polygon": {
            try {
              let geoSonData = JSON.parse(data.geoJson)
              let value = geoSonData.features[0].geometry.coordinates[0]
              newMapReference = { lat: value[0][0], lng: value[0][1] }
              updateMapCenterLatLng(newMapReference);
            } catch (e) { console.warn('MyContent polygon geoJson parse error', e) }
            break;
          }
          case "marker":
          case "photo": {
            newMapReference = {
              lat: data.latitude,
              lng: data.longitude,
            };
            updateMapCenterLatLng(newMapReference);
            break;
          }
          default:
            break;
        }
        if (newMapReference) {
          updateMapCenterLatLng(newMapReference);
        }
      }
    );
  }

  handleSortChange = (data) => {
    this.setState({ sortOption: data });
  };

  toggleDropdown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleOptionClick = (value) => {
    this.setState({
      isOpen: false,
    });
    this.handleSortChange(value);
  };

  handleSearchInputChange = (e) => {
    const { searchData } = this.state
    const searchQuery = e.target.value.toLowerCase();
    this.setState({ searchQuery }, () => {
      const filterData = searchData.length > 0 && searchData.filter((item) => {
        return item && item.name && item.name.toLowerCase().includes(this.state.searchQuery)
      });
      this.setState({ searchedData: filterData });
    });
  };


  handleClearSearch = () => {
    this.setState({ searchQuery: '' });
  };

  render() {
    let option = [{ label: 'New to Old', value: 'dateNewToOld' }, { label: 'Old to new', value: 'dateOldToNew' }, { label: 'A to Z', value: 'nameAtoZ' }, { label: 'Z to A', value: 'nameZtoA' }, { label: 'Closest', value: 'sortClosest' }, { label: 'Farthest', value: 'sortFarthest' }]
    const { isOpen, searchedData } = this.state;
    const { types, selectedType } = this.state
    const { collapseLeftToolbar } = this.props

    return (
      <div className='left-expanded-content-container'
        style={{ overflow: 'hidden' }}
      >
        <div className='left-expanded-header-container'>
          <span className='left-expanded-header'>My Content</span>
          <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
        </div>
        <div style={{ padding: '5px' }}>
          <div className='search-filter-container'>
            <div className='search-input-container'>
              <input
                className='search-style'
                type="text"
                placeholder="Search content by Name..."
                value={this.state.searchQuery}
                onChange={this.handleSearchInputChange}
              />
              {this.state.searchQuery && (
                <img
                  className='clear-icon'
                  src='../../../asset/Close-X_Thin_FFFFFF_ldpi.png'
                  alt='clear'
                  onClick={this.handleClearSearch}
                />
              )}
              {!this.state.searchQuery && (
                <img
                  className='search-icon'
                  src='../../../asset/Search_Solid_white_ldpi.png'
                  alt='search'
                  onClick={this.handleSearch}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', width: '340px', marginLeft: '5px', marginBottom: '5px' }}>
            <div style={{ width: '30px', display: 'flex', justifyContent: 'center' }}>
              <img
                src='../../asset/sort.png'
                style={{ height: 24, width: 24, cursor: 'pointer' }}
                alt="Sort Icon"
                onClick={this.toggleDropdown}
              />
            </div>
            {isOpen && (
              <div className='sort-by-options' >
                <ul className='ul-sort-option' style={{ listStyleType: 'none', padding: 0 }}>
                  {option.map(option => (
                    <li
                      key={option.value}
                      onClick={() => this.handleOptionClick(option)}
                      style={{ cursor: 'pointer' }}
                      className='sort-by-item'
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="sort-by-text" >
              <h3>Sort By : </h3>
            </div>
            <div className='sort-by-label'>
              <h3>{this.state.sortOption ? this.state.sortOption.label : 'none'}</h3>
            </div>
          </div>
          <div className='my-content-container'
            style={{ height: 'calc(100vh - 170px)' }}
          >
            {this.state.searchQuery == '' ?
              types.map((type, index) => this.makeExpandable(type, index))
              :
              searchedData.length > 0 ? this.expanded(searchedData) : <h1 className='no-data-found'>No data is there</h1>
            }
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  shapes: state.polygons.concat(state.circles, state.lines),
  markers: state.markers.filter(marker => marker &&
    marker.markerType.usageFlag != 3),
  huntStands: state.markers.filter(marker => (marker && marker.markerType.usageFlag == 3)
  ),
  photos: state.photos,
  tracks: state.tracks,
  routes: state.routes || [],
  boundaries: state.boundaries,
  lines: state.lines,
  polygons: state.polygons,
  circles: state.circles,
  mapReference: state.mapReference(),
  mapCenter: state.mapCenter,
  selectedObjId: state.selectedObjId,
  infoWindow: state.infoWindow,
  markersData: state.markers,
  hiddenContentTypes: state.hiddenContentTypes,
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  updateMapCenterLatLng: (payload) => dispatch(updateMapCenterLatLng(payload)),
  updateMapCenterNull: () => dispatch(updateMapCenterNull()),
  toggleContentTypeVisibility: (type) => dispatch(toggleContentTypeVisibility(type))
})

export default connect(mapStateToProps, mapDispatchToProps)(MyContent)
